import { render, staticRenderFns } from "./VExpertGuideBrowse.vue?vue&type=template&id=36532b0c&scoped=true&lang=pug"
import script from "./VExpertGuideBrowse.vue?vue&type=script&lang=ts"
export * from "./VExpertGuideBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VExpertGuideBrowse.vue?vue&type=style&index=0&id=36532b0c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36532b0c",
  null
  
)

/* custom blocks */
import block0 from "./GuideBrowse.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FGuide%2Fbrowse%2FVExpertGuideBrowse.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports